<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="largeheight1rr">Avertissement</p>
<p class="center1rr">Ce fichier ePub a été conçu par les Éditions Scholastic. Des problèmes d’affichage pourraient se produire lors de la lecture. Les Éditions Scholastic s’excusent de ces éventuels inconvénients, indépendants de leur volonté.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?65d28697